import { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
  Button,
  Stack,
  TextField,
  MenuItem,
  Grid
} from "@mui/material";

import PageHeader from "../../components/common/PageHeader";
import { getPayments } from "../../api/accountingApi";

export default function Payments() {

  const [payments, setPayments] = useState([]);

  const [filters, setFilters] = useState({
    currency: "",
    date_from: "",
    date_to: ""
  });

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const res = await getPayments(filters);
      setPayments(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error("Payments Error:", err);
    }
  };

  // =========================
  // FILTER CHANGE
  // =========================
  const handleFilterChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const applyFilters = () => {
    loadData();
  };

  // =========================
  // STATUS (DERIVED)
  // =========================
  const getStatus = (p) => {
    if (p.amount > 0) return "COMPLETED";
    return "UNKNOWN";
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "COMPLETED":
        return "success";
      default:
        return "default";
    }
  };

  // =========================
  // TOTALS
  // =========================
  const totals = payments.reduce(
    (acc, p) => {
      acc.total += p.amount || 0;
      return acc;
    },
    { total: 0 }
  );

  return (
    <Box className="page">

      {/* HEADER */}
      <PageHeader
        title="Payments"
        subtitle="Track all incoming and outgoing payments"
      />

      {/* FILTERS */}
      <Paper sx={{ p: 2, mb: 2, borderRadius: 3 }}>
        <Grid container spacing={2}>

          <Grid item xs={3}>
            <TextField
              select
              label="Currency"
              name="currency"
              fullWidth
              value={filters.currency}
              onChange={handleFilterChange}
            >
              <MenuItem value="">All</MenuItem>
              <MenuItem value="INR">INR</MenuItem>
              <MenuItem value="USD">USD</MenuItem>
            </TextField>
          </Grid>

          <Grid item xs={3}>
            <TextField
              type="date"
              label="From Date"
              name="date_from"
              fullWidth
              InputLabelProps={{ shrink: true }}
              value={filters.date_from}
              onChange={handleFilterChange}
            />
          </Grid>

          <Grid item xs={3}>
            <TextField
              type="date"
              label="To Date"
              name="date_to"
              fullWidth
              InputLabelProps={{ shrink: true }}
              value={filters.date_to}
              onChange={handleFilterChange}
            />
          </Grid>

          <Grid item xs={3}>
            <Button
              variant="contained"
              fullWidth
              sx={{ height: "100%" }}
              onClick={applyFilters}
            >
              Apply Filters
            </Button>
          </Grid>

        </Grid>
      </Paper>

      {/* TOTALS BAR */}
      <Paper sx={{ p: 2, mb: 2, borderRadius: 3 }}>
        <Stack direction="row" spacing={5}>
          <Typography variant="h6">
            Total Payments: ₹ {totals.total}
          </Typography>
        </Stack>
      </Paper>

      {/* ACTION BAR */}
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Typography variant="h6">Payment List</Typography>

        <Button variant="contained">
          Record Payment
        </Button>
      </Stack>

      {/* TABLE */}
      <Paper sx={{ borderRadius: 3 }}>

        <Table>

          <TableHead>
            <TableRow>
              <TableCell><b>ID</b></TableCell>
              <TableCell><b>Amount</b></TableCell>
              <TableCell><b>Currency</b></TableCell>
              <TableCell><b>FX Rate</b></TableCell>
              <TableCell><b>FCY</b></TableCell>
              <TableCell><b>LCY</b></TableCell>
              <TableCell><b>Date</b></TableCell>
              <TableCell><b>Status</b></TableCell>
            </TableRow>
          </TableHead>

          <TableBody>

            {payments.length === 0 ? (
              <TableRow>
                <TableCell colSpan={8} align="center">
                  No Payments Found
                </TableCell>
              </TableRow>
            ) : (
              payments.map((p) => {
                const status = getStatus(p);

                return (
                  <TableRow key={p.id} hover>

                    <TableCell>{p.id}</TableCell>

                    <TableCell>₹ {p.amount}</TableCell>

                    <TableCell>{p.currency}</TableCell>

                    <TableCell>{p.exchange_rate}</TableCell>

                    <TableCell>{p.fcy_amount || 0}</TableCell>

                    <TableCell>{p.lcy_amount || 0}</TableCell>

                    <TableCell>{p.payment_date || "-"}</TableCell>

                    <TableCell>
                      <Chip
                        label={status}
                        color={getStatusColor(status)}
                        size="small"
                      />
                    </TableCell>

                  </TableRow>
                );
              })
            )}

          </TableBody>

        </Table>

      </Paper>
    </Box>
  );
}